import styles from './ScreenReaderBundleFeatures.module.scss';

import cx from 'classnames';
import React, { HTMLAttributes } from 'react';

import type { Bundle } from 'api/contentful/contentTypes.cloverdotcom';
import { useTranslation } from 'react-i18next';
import type { FlatEntry } from 'services/cms/flattenContentful';
import { componentKeyV2 } from 'utils/ComponentKeyV2';
import { TextV2 } from '../TextV2/TextV2';

interface IScreenReaderBundleFeaturesProps extends HTMLAttributes<HTMLDivElement> {
  bundles?: Array<FlatEntry<Bundle>>;
}

export const ScreenReaderBundleFeatures: React.FC<IScreenReaderBundleFeaturesProps> = ({
  bundles,
  className,
  ...props
}) => {
  const { t } = useTranslation();

  if (!bundles) return null;

  return (
    <div className={cx(styles.screenReaderFeatures, className)} {...props}>
      {bundles.map((item, index) => (
        <ul
          key={componentKeyV2(item, index)}
          aria-label={t('bundle-summary-card.bundle-features', { title: item.title })}
        >
          {item.bundleSummaryFeatureValues?.map((item, index) => (
            <li key={componentKeyV2(item, index)}>
              <TextV2 value={item.description} />
            </li>
          ))}
        </ul>
      ))}
    </div>
  );
};

ScreenReaderBundleFeatures.displayName = 'ScreenReaderBundleFeatures';
